module.exports = __webpack_public_path__ + "media/sun_m.646832f4.mp3";